var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.$route.meta.key || _vm.$route.name})
}
var staticRenderFns = []

export { render, staticRenderFns }